import Header from '@Web/Pages/Web/Layout/Components/Header';
import Footer from '@Web/Pages/Web/Layout/Components/Footer';
import CookieBanner from '@Web/Src/Components/CookieBanner';
import WidgetScript from '@Web/Src/Components/Widget';
import { useState } from 'react';

function Layout({ children, lightTheme = true }) {
    const [menuOpened, setMenuOpened] = useState(false);

    return (
        <div className='relative font-sans' style={{ zoom: 0.8 }}>
            <Header
                menuOpened={menuOpened}
                setMenuOpened={setMenuOpened}
                lightTheme={lightTheme}
            />
            <div className='w-full'>{children}</div>
            <CookieBanner />
            <WidgetScript />
            <Footer />
        </div>
    );
}

export default Layout;
